import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { ImportFile } from 'src/app/models/ImporFile';

@Injectable({
    providedIn: 'root'
})
export class ImportFileApi extends Api<ImportFile> {
}
